import { defineStore } from 'pinia'

export const useNotificationsStore = defineStore('notifications', () => {
  const unreadCount = ref(0)
  const hasUnread = computed(() => unreadCount.value > 0)

  return {
    unreadCount,
    hasUnread,
  }
})
